import React from 'react';
import Post from '../../components/Post';

function Resources(props) {
  return (
    <Post {...props} />
  )
}

export default Resources;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Resources/index.js